"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatQuizPoints = exports.totalQuizPoints = exports.userQuizQuestionScore = exports.totalUserQuizPoints = void 0;
/**
 * Calculates the total points that that user scored against a quiz
 * @param survey Quiz to evaluate the user points against
 * @param userResponse User response to the quiz
 */
const totalUserQuizPoints = (questions, userResponse) => {
    return userResponse.responses.reduce((a, r) => {
        const question = questions.find(q => q.id === r.questionId);
        const questionScore = (0, exports.userQuizQuestionScore)(question, userResponse);
        if (questionScore) {
            return a + questionScore;
        }
        return a;
    }, 0);
};
exports.totalUserQuizPoints = totalUserQuizPoints;
/**
 * Gets the users score for a quiz question.  Returns undefined if no answer to the question
 * @param question Question to check the users score against
 * @param userResponse User response to the quiz
 */
const userQuizQuestionScore = (question, userResponse) => {
    const questionResponse = userResponse.responses.find(r => r.questionId === question.id);
    if (!questionResponse) {
        return undefined;
    }
    const correctIds = question.choices.filter(c => c.correct).map(c => c.id);
    const responseIds = !Array.isArray(questionResponse.value)
        ? [questionResponse.value]
        : questionResponse.value;
    if (correctIds.length === responseIds.length &&
        correctIds.reduce((a, v) => a && responseIds.includes(v), true)) {
        return question.pointValue || 1;
    }
    return 0;
};
exports.userQuizQuestionScore = userQuizQuestionScore;
/**
 * Gets the total number of points available for a quiz
 * @param survey Survey to get total points for
 */
const totalQuizPoints = (survey) => {
    return survey.questions.reduce((a, c) => a + (c.pointValue || 1), 0);
};
exports.totalQuizPoints = totalQuizPoints;
/**
 *
 * @param points pointValue for question choice
 * @param long If true, uses "point" or "points". If false, uses "pt" or "pts"
 */
const formatQuizPoints = (points, long) => {
    return `${points} ${long ? "point" : "pt"}${typeof points === "string" || points > 1 ? "s" : ""}`;
};
exports.formatQuizPoints = formatQuizPoints;
//# sourceMappingURL=quizCalculator.js.map